// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.il34y3jB92DWCg75v1SA{display:flex;flex-direction:column;gap:18px}.wKbCvaJwtI7hPEl_yjyL{display:flex;flex-direction:column}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/members/ui/actions/downgradeMember/ui/DowngradeMemberModal/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,QAAA,CAGF,sBACE,YAAA,CACA,qBAAA","sourcesContent":[".content {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `il34y3jB92DWCg75v1SA`,
	"section": `wKbCvaJwtI7hPEl_yjyL`
};
export default ___CSS_LOADER_EXPORT___;
